const setItem = (key, value) => {
  let existingConfig = localStorage.getItem('RPCConfig');
  existingConfig = existingConfig ? JSON.parse(existingConfig) : {};
  existingConfig[key] = value;
  localStorage.setItem('RPCConfig', JSON.stringify(existingConfig));
};

const setAddress = (address) => setItem('address', address);
const setToken = (token) => setItem('token', token);
const setPrefNftToken = (token) => setItem('prefNftToken', token);

const getAll = () => localStorage.getItem('RPCConfig');

const getItem = (key) => {
  let existingConfig = localStorage.getItem('RPCConfig');
  existingConfig = existingConfig ? JSON.parse(existingConfig) : {};
  return existingConfig[key];
};

const getAddress = () => getItem('address');
const getToken = () => getItem('token');
const getPrefNftToken = () => getItem('prefNftToken');

const clear = () => {
  localStorage.setItem('RPCConfig', JSON.stringify({}));
};

const removeItem = (key) => {
  let existingConfig = localStorage.getItem('RPCConfig');
  existingConfig = existingConfig ? JSON.parse(existingConfig) : {};

  existingConfig[key] ? delete existingConfig[key] : null;
  localStorage.setItem('RPCConfig', JSON.stringify(existingConfig));
};

export default {
  setItem,
  setAddress,
  setToken,
  setPrefNftToken,
  getItem,
  getAddress,
  getToken,
  getPrefNftToken,
  clear,
  removeItem,
  getAll
};
